import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

type Tone = "active" | "inactive" | "muted" | "warning";

const toneClasses: Record<Tone, string> = {
  active: "border-teal-300/40 bg-teal-300/10 text-teal-100",
  inactive: "border-red-300/35 bg-red-400/10 text-red-100",
  muted: "border-cyan-300/20 bg-white/5 text-content-secondary",
  warning: "border-amber-300/40 bg-amber-300/10 text-amber-100",
};

export function StatusBadge({ children, tone = "muted" }: { children: ReactNode; tone?: Tone }) {
  return (
    <span className={cn("inline-flex rounded border px-2 py-1 text-xs font-semibold uppercase tracking-[0.16em]", toneClasses[tone])}>
      {children}
    </span>
  );
}
